/**
 * Build Cart Types
 *
 * Type definitions for the build cart feature
 */

/**
 * Build Cart Phase
 */
export enum BuildCartPhase {
  CART = 'cart',
  TRAY = 'tray',
}

/**
 * Build Cart Progress Information
 */
export interface BuildCartProgress {
  traysLoaded: number;
  traysRequired: number;
  instrumentsSuppliesLoaded: number;
  instrumentsSuppliesRequired: number;
}

/**
 * Build Cart DTO (Data Transfer Object)
 * Used for serialization/deserialization
 */
export interface BuildCartDTO {
  caseId: string;
  currentPhase: BuildCartPhase;
  selectedCartId?: string;
  selectedCartLocation?: string;
  selectedCartReferenceNumber?: string;
  traysLoaded: number;
  traysRequired: number;
  instrumentsSuppliesLoaded: number;
  instrumentsSuppliesRequired: number;
}
